import { Cycle } from 'types/Cycle';

import { useCyclesQuery } from './baseState/useCyclesQuery';

export const useCyclesAwaitable = () => {
  const { data, isSuccess } = useCyclesQuery();
  return isSuccess
    ? { loading: false, data: data.cycles }
    : { loading: true, data: null };
};

export const useCycles = (): Cycle[] => {
  const { loading, data } = useCyclesAwaitable();
  return loading ? [] : data;
};

export const useInvalidateCycles = () => {
  const query = useCyclesQuery();
  const invalidateCycles = () => query.refetch();
  return invalidateCycles;
};
